import { UseQueryOptions } from '@tanstack/react-query'

import { useEntitiesQuery, usePostEntityMutation } from 'src/queries/entity'

import { UsePostEntityArgs } from '../../queryGenerator'

export const CHAT_ENDPOINT = 'chat'
export const CHAT_QUERY_KEY = 'chat'

interface CreateChatChannelsQueryParams {
  buyerCompanyId: Id
  marketplaceId: Id
  sellerCompanyId: Id
}

type CreateChatChannelsResponse = { channelId: string }

export const useCreateChatChannelsMutation = (
  args: UsePostEntityArgs<CreateChatChannelsResponse, CreateChatChannelsQueryParams> = {}
) =>
  usePostEntityMutation<CreateChatChannelsQueryParams, CreateChatChannelsResponse>({
    endpoint: `${CHAT_ENDPOINT}/channels`,
    ...args,
  })

export type ChatToken = { token: string }

interface UseChatTokenQueryArgs<TData> {
  contextualMembershipId?: Id
  queryOptions?: UseQueryOptions<ChatToken, Error, TData>
}

export const useBuyerChatTokenQuery = <TData = ChatToken>({
  contextualMembershipId,
  queryOptions,
}: UseChatTokenQueryArgs<TData>) =>
  useEntitiesQuery<ChatToken, {}, TData>({
    contextualMembershipId,
    endpoint: `${CHAT_ENDPOINT}/token`,
    queryKey: `${CHAT_QUERY_KEY}BuyerToken`,
    queryOptions: {
      cacheTime: 1000 * 60 * 120,
      staleTime: 1000 * 60 * 60,
      ...queryOptions,
    },
  })

export const useSellerChatTokenQuery = <TData = ChatToken>({
  contextualMembershipId,
  queryOptions,
}: UseChatTokenQueryArgs<TData>) =>
  useEntitiesQuery<ChatToken, {}, TData>({
    contextualMembershipId,
    endpoint: `${CHAT_ENDPOINT}/token`,
    queryKey: `${CHAT_QUERY_KEY}SellerToken`,
    queryOptions: {
      cacheTime: 1000 * 60 * 120,
      staleTime: 1000 * 60 * 60,
      ...queryOptions,
    },
  })
